import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/arrow-right" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M5.5 12H19.5", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { id: "Vector_2", d: "M12.5 5L19.5 12L12.5 19", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
